import type { ComponentProps } from 'react';
import { type VariantProps } from 'class-variance-authority';
import { buttonVariants } from '@/components/ui/buttonVariants';
import { cn } from '@/lib/utils';

type ButtonLook = VariantProps<typeof buttonVariants>;

function patientButtonClass({ variant, size }: ButtonLook, className?: string) {
  return cn(
    buttonVariants({ variant, size }),
    'font-patient-display text-base font-semibold',
    className
  );
}

/**
 * ui/Button with its UNMASK_PROPS left off: on the patient pages even button
 * copy stays masked in replay (patientReplayMasking.test.tsx).
 */
export function PatientPortalButton({
  className,
  variant,
  size = 'md',
  type = 'button',
  ...props
}: ComponentProps<'button'> & ButtonLook) {
  return (
    <button
      type={type}
      className={patientButtonClass({ variant, size }, className)}
      {...props}
    />
  );
}

/** The same button for a link out of the app, such as the marketing site. */
export function PatientPortalButtonLink({
  className,
  variant,
  size = 'md',
  ...props
}: ComponentProps<'a'> & ButtonLook) {
  return (
    <a
      className={patientButtonClass({ variant, size }, className)}
      {...props}
    />
  );
}
